import React, { useState, useEffect } from 'react';
import { Ifield } from '../types';
import { FormControl, InputAdornment, TextField } from '@mui/material';
import { getErrorText } from '..';
// import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux.hooks';
import TodayIcon from '@mui/icons-material/Today';
import { CustomTextField } from '../../../theme/elements/Inputs';
import { filterDates } from '../../../components/FormElements/DateRange';
import { defineds } from 'constants/ui.constants';
import { getReportDates, setReportDates } from 'state/reducers/reports.reducers';
import { useTheme } from '@mui/material';
import DateRangePopover from 'components/FormElements/DateRangePopover';

type props = {
	valid: boolean;
	cField: Ifield;
	initialValidation: any;
	handleChange: any;
};

export const DateRangePickerInput = (props: props) => {
	const dispatch = useAppDispatch();
	const theme = useTheme();
	// const t = useAppSelector(selectTranslations);
	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
	const { valid, cField, initialValidation } = props;
	const { name, value, helperText } = cField.props;
	const [showCalender, setShowCalender] = useState(false);
	const id = showCalender ? 'simple-calender-popover' : undefined;
	const dateRange = useAppSelector(getReportDates);
	const companyStartDate = cField.props.options;

	const intialDates: filterDates = {
		startDate: defineds.startOfToday,
		endDate: defineds.endOfToday,
	};

	const [state, setState] = useState([
		{
			startDate: intialDates.startDate,
			endDate: intialDates.endDate,
			key: 'selection',
			companyStartDate,
		},
	]);

	useEffect(() => {
		setState([
			{
				startDate: dateRange.startDate || intialDates.startDate,
				endDate: dateRange.endDate || intialDates.endDate,
				key: 'selection',
				companyStartDate,
			},
		]);
	}, [dateRange]);

	useEffect(() => {
		setState((prevState) => [
			{
				...prevState[0],
				companyStartDate: companyStartDate,
			},
		]);
	}, [companyStartDate]);

	const handleClose = () => {
		setAnchorEl(null);
		setShowCalender(false);
	};

	const handleSelect = (ranges: any) => {
		if (companyStartDate) {
			handleClose();
			dispatch(setReportDates({ startDate: ranges.selection.startDate, endDate: ranges.selection.startDate }));
			return;
		}
		dispatch(setReportDates({ startDate: ranges.selection.startDate, endDate: ranges.selection.endDate }));
	};

	const handleClick = (event: any) => {
		setAnchorEl(event.currentTarget);
		setShowCalender(true);
	};

	const handleChangeDatePick = (item: any) => {
		setState([item.selection]);
		handleSelect(item);
	};

	return (
		<CustomTextField key={name}>
			<FormControl error={!valid} fullWidth sx={cField.styleObj}>
				<TextField
					error={!valid}
					{...cField.props}
					helperText={valid ? helperText : getErrorText(initialValidation, name)}
					value={['null', 'undefined'].includes(typeof value) ? '' : value}
					onClick={props.cField.props.disabled ? undefined : handleClick}
					variant="filled"
					autoComplete="off"
					InputProps={{
						readOnly: true,
						endAdornment: (
							<InputAdornment position="end">
								<TodayIcon
									sx={{
										color: showCalender
											? theme.palette.root.orange
											: theme.palette.root.basicDeeoGreen,
									}}
								/>
							</InputAdornment>
						),
					}}
				/>
				<DateRangePopover
					id={id}
					showCalender={showCalender}
					anchorEl={anchorEl}
					state={state}
					handleClose={handleClose}
					onChange={handleChangeDatePick}
					months={cField?.months}
				/>
			</FormControl>
		</CustomTextField>
	);
};
